var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50806 0.879883L8.54587 11.1399L1.65712 19.1199H3.18337L9.21993 12.1224L14.0199 19.1199H19.7865L12.4337 8.40144L18.9221 0.879883H17.4006L11.7587 7.41613L7.27462 0.879883H1.50806ZM3.33056 1.83988H6.76931L17.964 18.1599H14.5252L3.33056 1.83988Z",
    fill: "#000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweet);
export default __webpack_public_path__ + "static/media/tweet.2355de701c185436f3bc1130a00fe97e.svg";
export { ForwardRef as ReactComponent };